import React, { useState, useEffect, useCallback, useContext } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { generateExcelFile } from "../../../shared/components/excelUtils/exportExcel";
import { useHttpClient } from "../../../shared/hooks/http-hook";
import toast from "react-hot-toast";
import dataGridData from "./components/datagridData";
import { useLoading } from "../../../shared/context/LoadingContext";
//Modais
import ModalVerEntrada from "./components/modalEntrada/ModalVerEntrada";
import ModalEntrada from "./components/modalEntrada/ModalEntrada";
import ModalEditarEntrada from "./components/modalEntrada/ModalEditarEntrada";
import ModalVerOrcamento from "../../clientes/single/components/OrcamentosComponent/components/ModalVerOrcamento/ModalVerOrcamento";
//ICONS
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import ErrorIcon from "@mui/icons-material/Error";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import CancelIcon from "@mui/icons-material/Cancel";
//Antd
import { Popover } from "antd";
import { Popconfirm } from "antd";
import { DataGrid } from "@mui/x-data-grid";
import FiltrosReceitas from "./components/filtrosReceitas/FiltrosReceitas";

//MUI
import Button from "@mui/material/Button";
import ModalReceberEntrada from "./components/modalEntrada/ModalReceberEntrada";
import ModalMotivoCancelamentoEntradas from "./components/ModalMotivoCancelamentoEntradas/ModalMotivoCancelamentoEntradas";
import ModalCorrigirCaixa, {
  podeCorrigirCaixa,
} from "../../../shared/components/modalCorrigirCaixa/ModalCorrigirCaixa";
import { ClinicaContext } from "../../../shared/context/clinica-context";
import { dadosImpressao } from "../../../shared/util/dadosImpressao";
import {
  podeAlterarRegisto,
  motivoBloqueioUnidade,
  paramsUnidadeDados,
} from "../../../shared/util/unidadeRegisto";
import SeletorUnidadeDados, {
  TODAS_UNIDADES,
} from "../../../shared/components/badgeUnidade/SeletorUnidadeDados";
import BadgeUnidade from "../../../shared/components/badgeUnidade/BadgeUnidade";
import SeloSoConsulta from "../../../shared/components/badgeUnidade/SeloSoConsulta";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";

import TextField from "@mui/material/TextField";
import { useContingenciaEfatura } from "../../../shared/hooks/contingencia-efatura-hook";

const MOTIVOS_CONTINGENCIA = [
  { codigo: 1, label: "Indisponibilidade do serviço de autorização de DFEs" },
  { codigo: 2, label: "Falta de energia elétrica no estabelecimento" },
  { codigo: 3, label: "Indisponibilidade do sistema do contribuinte" },
  { codigo: 4, label: "Indisponibilidade de conexão Internet" },
  { codigo: 5, label: "Indisponibilidade do serviço de TimeStamp" },
  { codigo: 0, label: "Outro (especificar)" },
];

function Receitas({ clinicaId, auth, showFatura, showRce, dadosClinica }) {
  const clinica = useContext(ClinicaContext);
  const { modoContingenciaAtivo } = useContingenciaEfatura();
  const { startLoading, stopLoading } = useLoading();

  const { sendRequest } = useHttpClient();
  const [rows, setRows] = useState([]);
  const [modalData, setModalData] = useState({});
  const [parcelas, setParcelas] = useState([]);
  const [parcelasAbsolut, setParcelasAbsolut] = useState([]);
  const [parcelasParaTextSearch, setParcelasParaTextSearch] = useState([]);
  const [entradas, setEntradas] = useState([]);
  const [entradasAbsolut, setEntradasAbsolut] = useState([]);
  const [entradasParaTextSearch, setEntradasParaTextSearch] = useState([]);
  const [entradaId, setEntradaId] = useState();
  const [openModal, setOpenModal] = useState("");
  /* Id da entrada a editar (caixa, descrição e observação). Abre a partir do
     menu da linha, e não de outra janela — por isso vive fora do `openModal`. */
  const [corrigirCaixa, setCorrigirCaixa] = useState(null);
  const [filtrosAplicados, setFiltrosAplicados] = useState([]);
  const [filtroCaixa, setFiltroCaixa] = useState();
  const [filtroCategoria, setFiltroCategoria] = useState();
  const [filtroMetodoPagamento, setFiltroMetodoPagamento] = useState();
  const [filtroTextoSearch, setFiltroTextoSearch] = useState("");
  const [
    dadosModalMotivoCancelamentoEntradas,
    setDadosModalMotivoCancelamentoEntradas,
  ] = useState({
    open: false,
  });
  const [financialData, setFinancialData] = useState({
    totalRecebido: 0,
    totalReceber: 0,
    totalPrevistoReceber: 0,
    saldo: 0,
    saldoTotalPrevisto: 0,
  });

  //Emissão em contingência
  const [dialogContingenciaOpen, setDialogContingenciaOpen] = useState(false);
  const [dadosContingenciaPendente, setDadosContingenciaPendente] =
    useState(null);
  const [motivoContingenciaSelecionado, setMotivoContingenciaSelecionado] =
    useState(1);
  const [descricaoContingenciaOutro, setDescricaoContingenciaOutro] =
    useState("");

  /* De que unidade são os dados deste ecrã. Arranca na da sessão.
     Não é um filtro — muda o PEDIDO. Ver `SeletorUnidadeDados`. */
  const [unidadeDados, setUnidadeDados] = useState(
    () => auth.estabelecimento?._id ?? null,
  );

  /* O período em curso. As datas vivem no componente de filtros e não subiam
     até aqui; sem isto, trocar de unidade voltava sempre ao dia de hoje. */
  const [periodoAtual, setPeriodoAtual] = useState(() => ({
    inicio: moment().startOf("day").toISOString(),
    fim: moment().endOf("day").toISOString(),
  }));

  const fetchContasCorrentesEntrada = useCallback(
    async (startDate, endDate, unidade = unidadeDados) => {
      startLoading();
      setPeriodoAtual({ inicio: startDate, fim: endDate });
      try {
        const formData = new FormData();
        formData.append("startDate", startDate);
        formData.append("endDate", endDate);

        /* A unidade vai no PEDIDO — os dois endpoints partilham este FormData,
           por isso recebem forçosamente a mesma. Se divergissem, as parcelas e
           as entradas do ecrã seriam de sítios diferentes. */
        for (const [chave, val] of Object.entries(
          paramsUnidadeDados(unidade, auth),
        )) {
          formData.append(chave, String(val));
        }

        const requests = [];
        let responseDataParcelas = { parcelas: [] };
        let responseDataEntradas = { entradas: [] };

        if (auth.perm.includes("r-parc")) {
          requests.push(
            sendRequest(
              `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/financeiro/daterange/${clinicaId}`,
              "PATCH",
              formData,
              { Authorization: "Bearer " + auth.token },
            ),
          );
        }

        if (auth.perm.includes("r-ent")) {
          requests.push(
            sendRequest(
              `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/clinica/daterange/${clinicaId}`,
              "PATCH",
              formData,
              { Authorization: "Bearer " + auth.token },
            ),
          );
        }

        const responses = await Promise.all(requests);

        if (auth.perm.includes("r-parc")) {
          responseDataParcelas = responses.shift();
        }

        if (auth.perm.includes("r-ent")) {
          responseDataEntradas = responses.shift();
        }

        setParcelas(responseDataParcelas.parcelas);
        setParcelasAbsolut(responseDataParcelas.parcelas);
        setEntradas(responseDataEntradas.entradas);
        setEntradasAbsolut(responseDataEntradas.entradas);
        setParcelasParaTextSearch(responseDataParcelas.parcelas);
        setEntradasParaTextSearch(responseDataEntradas.entradas);

        handleFiltrar(
          responseDataParcelas.parcelas,
          responseDataEntradas.entradas,
          [],
          null,
          null,
          null,
          "",
          {
            dataInicial: moment(startDate).format("DD/MM/YYYY"),
            dataFinal: moment(endDate).format("DD/MM/YYYY"),
          },
        );
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    },
    [auth, auth.perm, auth.token, clinicaId, sendRequest, unidadeDados],
  );

  useEffect(() => {
    fetchContasCorrentesEntrada(
      moment().startOf("day").toISOString(),
      moment().endOf("day").toISOString(),
    );
  }, []);

  /* Trocar de unidade é um pedido novo, não um recorte do que já veio — e
     mantém o período que estava à vista. */
  const trocarUnidade = (nova) => {
    setUnidadeDados(nova);
    fetchContasCorrentesEntrada(periodoAtual.inicio, periodoAtual.fim, nova);
  };

  /* No consolidado, cada linha diz de que unidade é. Numa unidade só, não —
     seria a mesma pastilha repetida em todas as linhas. */
  const verTodasUnidades = unidadeDados === TODAS_UNIDADES;

  useEffect(() => {
    let dataParaDataGrid = [];
    let recebido = 0;
    let porReceber = 0;

    parcelas.forEach((parcela) => {
      recebido += parcela.quantiaPaga;
      if (parcela.status !== "CANCELADA") {
        porReceber += parcela.quantiaPorPagar;
      }
      dataParaDataGrid.push({
        tipo: "receita",
        cliente: parcela.contaCorrente.cliente.nome,
        idCliente: parcela.contaCorrente.cliente._id,
        dadosCliente: parcela.contaCorrente.cliente,
        idContaCorrente: parcela.contaCorrente._id,
        orcamento: parcela.conta.orcamento,
        id: parcela._id,
        contaId: parcela.conta._id,
        dataLimitePagamento: parcela.dataLimitePagamento,
        dataPagamento: parcela.dataPagamento,
        quantiaPorPagar: parcela.quantiaPorPagar,
        quantiaPaga: parcela.quantiaPaga,
        metodoPagamento: parcela.metodoPagamento,
        nrParcela: parcela.nrParcela,
        parcelaPaga: parcela.parcelaPaga,
        estado: parcela.parcelaPaga
          ? "Pago"
          : moment()
                .startOf("day")
                .isAfter(moment(parcela.dataLimitePagamento).startOf("day"))
            ? "Em atraso"
            : "",
        documentoEletronico: parcela.documentoEletronico,
        faturaEReciboEletronicos: parcela.faturaEReciboEletronicos,
        cancelamentosRecibosEletronicos:
          parcela.cancelamentosRecibosEletronicos,
        nrRecibo: parcela.nrRecibo,
        cancelamentosDocumentosEletronicos:
          parcela.cancelamentosDocumentosEletronicos,
        categoria: parcela.categoria?.categoria,
        caixa: parcela.caixa?.caixa,
        // Unidade do movimento: a do proprio registo, ou a da caixa onde o
        // dinheiro entrou (registos anteriores ao carimbo).
        estabelecimento:
          parcela.estabelecimento || parcela.caixa?.estabelecimento,
        status: parcela.status,
        motivoEncerramento: parcela.conta.motivoEncerramento,
        recebidoPor: parcela.recebidoPor?.user?.name || "",
        dataRecebimento: parcela.recebidoPor?.data
          ? moment(parcela.recebidoPor?.data).format("DD/MM/YYYY HH:mm")
          : "",
        emitidoPor: parcela.documentoEletronico?.usuarioEmissor?.name,
        dataEmissao: parcela.documentoEletronico?.created_at
          ? moment(parcela.documentoEletronico?.created_at).format(
              "DD/MM/YYYY HH:mm",
            )
          : "",
        fteEmitidoPor:
          parcela.faturaEReciboEletronicos?.fte?.usuarioEmissor?.name,
        dataEmissaoFte: parcela.faturaEReciboEletronicos?.fte?.created_at
          ? moment(parcela.faturaEReciboEletronicos?.fte?.created_at).format(
              "DD/MM/YYYY HH:mm",
            )
          : "",
        rceEmitidoPor:
          parcela.faturaEReciboEletronicos?.rce?.usuarioEmissor?.name,
        dataEmissaoRce: parcela.faturaEReciboEletronicos?.rce?.created_at
          ? moment(parcela.faturaEReciboEletronicos?.rce?.created_at).format(
              "DD/MM/YYYY HH:mm",
            )
          : "",
      });
    });

    if (entradas && entradas.length > 0) {
      entradas.forEach((entrada) => {
        if (entrada.entradaRecebida && entrada.valor) {
          recebido += entrada.valor;
        } else {
          porReceber += entrada.valor;
        }
        dataParaDataGrid.push({
          tipo: "entrada",
          tipoEntrada: entrada.tipo,
          id: entrada.id,
          cliente: entrada.clienteFornecedor
            ? entrada.clienteFornecedor
            : entrada.cliente,
          dataCriacao: entrada.created_at,
          dataPagamento: entrada.dataPagamento,
          dataLimitePagamento: entrada.dataLimitePagamento,
          valor: entrada.valor,
          metodoPagamento: entrada.metodoPagamento,
          descricao: entrada.descricao,
          comprovativo: entrada.comprovativo,
          nrRecibo: entrada.nrRecibo,
          documentoEletronico: entrada.documentoEletronico,
          entradaRecebida: entrada.entradaRecebida,
          faturaEReciboEletronicos: entrada.faturaEReciboEletronicos,
          cancelamentosDocumentosEletronicos:
            entrada.cancelamentosDocumentosEletronicos,
          cancelamentosRecibosEletronicos:
            entrada.cancelamentosRecibosEletronicos,
          categoria: entrada.categoria?.categoria,
          caixa: entrada.caixa?.caixa,
          estabelecimento:
            entrada.estabelecimento || entrada.caixa?.estabelecimento,
          recebidoPor: entrada.recebidoPor?.user?.name || "",
          dataRecebimento: entrada.recebidoPor?.data
            ? moment(entrada.recebidoPor?.data).format("DD/MM/YYYY HH:mm")
            : "",
          emitidoPor: entrada.documentoEletronico?.usuarioEmissor?.name,
          dataEmissao: entrada.documentoEletronico?.created_at
            ? moment(entrada.documentoEletronico?.created_at).format(
                "DD/MM/YYYY HH:mm",
              )
            : "",
          rceEmitidoPor:
            entrada.faturaEReciboEletronicos?.rce?.usuarioEmissor?.name,
          dataEmissaoRce: entrada.faturaEReciboEletronicos?.rce?.created_at
            ? moment(entrada.faturaEReciboEletronicos?.rce?.created_at).format(
                "DD/MM/YYYY HH:mm",
              )
            : "",
        });
      });
    }

    dataParaDataGrid = dataParaDataGrid.sort(
      (a, b) =>
        new Date(a.dataPagamento ? a.dataPagamento : a.dataLimitePagamento) -
        new Date(b.dataPagamento ? b.dataPagamento : b.dataLimitePagamento),
    );

    setFinancialData({
      totalRecebido: recebido.toLocaleString("pt-BR"),
      totalReceber: porReceber.toLocaleString("pt-BR"),
    });

    setRows(dataGridData(dataParaDataGrid));
  }, [parcelas, entradas]);

  //A funcao verifica o nif e compara com o nome retornado para ver se é identico
  const handleCloseModal = useCallback(() => {
    setOpenModal("");
    setModalData("");
    setDadosModalMotivoCancelamentoEntradas({});
  }, []);

  const desativarEntradaHandler = async (id) => {
    startLoading();
    try {
      const formDataEntradaDesativar = new FormData();
      formDataEntradaDesativar.append("utilizador", auth.userId);

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/toggleativo/${id}`,
        "PATCH",
        formDataEntradaDesativar,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      const tempEntradas = [...entradas];
      const tempEntradasAbsolut = [...entradasAbsolut];
      const tempEntradasParaTextSearch = [...entradasParaTextSearch];

      const indexEntrada = tempEntradas.findIndex(
        (entrada) => entrada._id === id,
      );

      const indexEntradaAbsolut = tempEntradasAbsolut.findIndex(
        (entrada) => entrada._id === id,
      );

      const indexEntradaParaTextSearch = tempEntradasParaTextSearch.findIndex(
        (entrada) => entrada._id === id,
      );

      tempEntradas.splice(indexEntrada, 1);
      tempEntradasAbsolut.splice(indexEntradaAbsolut, 1);
      tempEntradasParaTextSearch.splice(indexEntradaParaTextSearch, 1);
      setEntradas([...tempEntradas]);
      setEntradasAbsolut([...tempEntradasAbsolut]);
      setEntradasParaTextSearch([...tempEntradasParaTextSearch]);

      toast.success("Entrada desativada com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const verEntradaHandler = (id) => {
    const entradaFiltrada = entradas.filter((entr) => entr.id === id)[0];
    setModalData(entradaFiltrada);
    setOpenModal("verEntrada");
  };

  const editarEntradaHandler = (id) => {
    setEntradaId(id);
    setOpenModal("editarEntrada");
  };

  const handleOpenModalProcedimentos = async (orcamentoId) => {
    startLoading();
    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/orcamentos/${orcamentoId}`,
        "GET",
        null,
        { Authorization: "Bearer " + auth.token },
      );
      setModalData(responseData.orcamento);
      setOpenModal("procedimentos");
    } catch (err) {
      console.error(err);
    } finally {
      stopLoading();
    }
  };

  const handleOpenModalReceberEntrada = (id) => {
    const entradaFiltada = entradas.filter((e) => e.id === id)[0];
    setModalData(entradaFiltada);
    setOpenModal("receberEntrada");
  };

  const handleBeforeCancelarRecebimentoEntrada = (
    id,
    enviarDocCancelamento,
  ) => {
    const entradaFiltrada = entradas.find((e) => e.id === id);

    if (!enviarDocCancelamento) {
      const handler = handleCancelarRecebimentoEntradaClienteFornecedor;

      return handler(entradaFiltrada);
    }

    setDadosModalMotivoCancelamentoEntradas({
      open: "motivoCancelamentoEntradas",
      entrada: entradaFiltrada,
      tipoEntrada: entradaFiltrada.tipo,
      tipoDocumento: "Event",
      tipoDocumentoAnular: "RCE",
    });
  };

  const handleBeforeNCEEntrada = (id) => {
    const entradaFiltrada = entradas.find((e) => e.id === id);
    setDadosModalMotivoCancelamentoEntradas({
      open: "motivoCancelamentoEntradas",
      entrada: entradaFiltrada,
      tipoDocumento: "NCE",
      apenasEmitir: true,
      tipoDocumentoAnular: entradaFiltrada.documentoEletronico.tipoDocumento,
      documentoEmContingencia:
        entradaFiltrada.documentoEletronico?.emitidoEmContingencia || false,
    });
  };

  const handleCancelarRecebimentoEntradaClienteFornecedor = async (
    entradaFiltrada,
    enviarDocCancelamento,
    motivoCancelamento,
  ) => {
    startLoading();
    try {
      if (!enviarDocCancelamento) {
        const formData = new FormData();
        formData.append("canceladoPor", auth.userId);
        if (
          entradaFiltrada?.faturaEReciboEletronicos?.rce?.succeeded === false
        ) {
          formData.append(
            "rceId",
            entradaFiltrada.faturaEReciboEletronicos.rce._id,
          );
        }
        formData.append("entradaId", entradaFiltrada._id);

        const result = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/cancelarrecebimentoclientefornecedorsemdocumento/${entradaFiltrada._id}`,
          "PATCH",
          formData,
          { Authorization: "Bearer " + auth.token },
        );

        updateEntradas(result.entrada, "atualizar");
        toast.success("Recebimento cancelado com sucesso!");
        return;
      }

      // VALIDAÇÃO: Verificar se RCE original está em contingência
      const documentoOriginalEmContingencia =
        entradaFiltrada.faturaEReciboEletronicos?.rce?.emitidoEmContingencia ===
        true;

      // Prepare dados para evento de cancelamento
      const dadosCancelamento = {
        clinicaId: clinica.clinica._id,
        tipoDocEletronico: "Event",
        entradaId: entradaFiltrada._id,
        valor: entradaFiltrada.valor,
        usuarioEmissor: auth.userId,
        clinica: {
          nif: clinica.clinica.nif,
          nomeFiscal: clinica.clinica.nomeFiscal,
          endereco: clinica.clinica.endereco,
          contacto: clinica.clinica.contacto,
          email: clinica.clinica.email,
        },
        entrada: entradaFiltrada._id,
        IUDCancelar:
          entradaFiltrada.faturaEReciboEletronicos.rce.entryName.replace(
            /\.xml$/,
            "",
          ),
        idDocumentoAnular: entradaFiltrada.faturaEReciboEletronicos.rce._id,
        IssueReasonDescription: motivoCancelamento,
        online: !documentoOriginalEmContingencia, // NOVO
        // NOVOS CAMPOS
        emitirEmContingencia: documentoOriginalEmContingencia,
        motivoContingencia: documentoOriginalEmContingencia
          ? `Cancelamento de RCE emitido em contingência (${entradaFiltrada.faturaEReciboEletronicos.rce.entryName})`
          : undefined,
      };

      const formData = new FormData();
      formData.append("dadosCancelamento", JSON.stringify(dadosCancelamento));

      const resposta = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/cancelarrecebimentoclientefornecedor`,
        "POST",
        formData,
        { Authorization: "Bearer " + auth.token },
      );

      if (resposta.documento?.respostaEfatura?.responses[0]?.succeeded) {
        updateEntradas(resposta.entrada, "atualizar");
        const msgContingencia = documentoOriginalEmContingencia
          ? " em CONTINGÊNCIA (RCE original também está offline)"
          : "";
        toast.success(
          `Recebimento cancelado e Event emitido com sucesso${msgContingencia}!`,
        );
      } else {
        toast.error(
          `Erro ao emitir Event: ${resposta.documento?.respostaEfatura?.responses[0]?.messages[0]?.description}`,
        );
      }
    } catch (err) {
      console.error("Erro ao cancelar recebimento:", err);
      toast.error("Erro ao cancelar recebimento");
    } finally {
      stopLoading();
    }
  };
  //DFE
  //--------------------------------------------------------------

  // Função auxiliar para executar emissão de FTE
  const executarEmissaoFTE = async (dadosEmissao, operacao) => {
    const formData = new FormData();
    formData.append("dadosEmissao", JSON.stringify(dadosEmissao));

    const resposta = await sendRequest(
      `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/emitirdoceletronicoeatualizar`,
      "POST",
      formData,
      { Authorization: "Bearer " + auth.token },
    );

    if (!resposta) {
      throw new Error("Não houve resposta do servidor.");
    }

    updateEntradas(resposta.entrada, operacao);

    if (resposta.documento?.respostaEfatura?.responses[0]?.succeeded) {
      const msgContingencia = resposta.documento?.emitidoEmContingencia
        ? " em CONTINGÊNCIA"
        : "";
      toast.success(`FTE emitido com sucesso${msgContingencia}`);
    } else {
      toast.error(
        `Erro ao emitir FTE: ${resposta.documento?.respostaEfatura?.responses[0]?.messages[0]?.description}`,
      );
    }
  };

  // Função auxiliar para executar emissão de RCE
  const executarEmissaoRCE = async (dadosEmissao) => {
    const formData = new FormData();
    formData.append("dadosEmissao", JSON.stringify(dadosEmissao));

    const resposta = await sendRequest(
      `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/emitirrceatualizar`,
      "POST",
      formData,
      { Authorization: "Bearer " + auth.token },
    );

    updateEntradas(resposta.entrada, "atualizar");

    if (resposta.documento?.respostaEfatura?.responses[0]?.succeeded) {
      const msgContingencia = resposta.documento?.emitidoEmContingencia
        ? " em CONTINGÊNCIA"
        : "";
      toast.success(`RCE emitido com sucesso${msgContingencia}`);
    } else {
      toast.error(
        `Erro ao emitir RCE: ${resposta.documento?.respostaEfatura?.responses[0]?.messages[0]?.description}`,
      );
    }
  };

  // Função auxiliar para executar emissão de NCE
  const executarEmissaoNCE = async (dadosEmissao) => {
    const formData = new FormData();
    formData.append("dadosCancelamento", JSON.stringify(dadosEmissao));

    const resposta = await sendRequest(
      `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/emitirnceatualizar`,
      "POST",
      formData,
      { Authorization: "Bearer " + auth.token },
    );

    updateEntradas(resposta.entrada, "atualizar");

    if (resposta.documento?.respostaEfatura?.responses[0]?.succeeded) {
      const msgContingencia = resposta.documento?.emitidoEmContingencia
        ? " em CONTINGÊNCIA"
        : "";
      toast.success(`NCE emitido com sucesso${msgContingencia}`);
    } else {
      toast.error(
        `Erro ao emitir NCE: ${resposta.documento?.respostaEfatura?.responses[0]?.messages[0]?.description}`,
      );
    }
  };

  //Emitir FTE
  const emitirDocEletronico = async (entrada, idEntrada, operacao) => {
    startLoading();
    let dadosEmissao;
    try {
      let entradaFiltrada =
        entrada || entradas.find((e) => e._id === idEntrada);

      const dadosCliente = entradaFiltrada.clienteFornecedor;

      // Validate client data
      const validacao = validarDadosCliente(dadosCliente);
      if (!validacao.valido) {
        toast.error(validacao.erro);
        updateEntradas(entradaFiltrada, operacao);
        return;
      }

      // Prepare emission data
      dadosEmissao = {
        clinicaId: clinica.clinica._id,
        tipoDocEletronico: "FTE",
        valor: entradaFiltrada.valor,
        descricaoPagamento: entradaFiltrada.descricao,
        metodoPagamento: entradaFiltrada.metodoPagamento,
        dataLimitePagamento: entradaFiltrada.dataLimitePagamento,
        dataPagamento: entradaFiltrada.dataPagamento,
        usuarioEmissor: auth.userId,
        entrada: entradaFiltrada._id,
        online: true,
        clinica: {
          nif: clinica.clinica.nif,
          nomeFiscal: clinica.clinica.nomeFiscal,
          endereco: clinica.clinica.endereco,
          contacto: clinica.clinica.contacto,
          email: clinica.clinica.email,
        },
        nomeCliente: dadosCliente.nome,
        nifCliente: dadosCliente.nif,
        contactoCliente: dadosCliente.contacto,
        moradaCliente: dadosCliente.endereco,
        codigoPaisCliente: dadosCliente.pais.codigo,
      };

      // MODO CONTINGÊNCIA: Abre diálogo para escolher motivo
      if (modoContingenciaAtivo) {
        setDadosContingenciaPendente({
          tipo: "FTE",
          idEntrada,
          dados: dadosEmissao,
          operacao: operacao,
        });
        setDialogContingenciaOpen(true);
        stopLoading();
        return;
      }

      await executarEmissaoFTE(dadosEmissao, operacao);
    } catch (err) {
      console.error("Erro ao emitir documento:", err);
      toast.error("Ocorreu um erro ao emitir o documento");
    } finally {
      stopLoading();
    }
  };

  //Emitir NCE para quando se clica em anular fatura
  const emitirNCE = async (
    entrada,
    motivoCancelamento,
    valorCancelar,
    dadosContingencia,
  ) => {
    startLoading();
    let dadosCancelamento;

    try {
      const entradaFiltrada = entrada?._id
        ? entrada
        : entradas.find((e) => e.id === entrada);
      const clienteData = entradaFiltrada.clienteFornecedor;

      //Verificar se documento original está em contingência
      //Documentos em contingência só podem ser cancelados por documentos em contingência
      const documentoOriginalEmContingencia =
        entradaFiltrada.documentoEletronico?.emitidoEmContingencia === true;

      dadosCancelamento = {
        clinicaId: clinica.clinica._id,
        tipoDocEletronico: "NCE",
        entradaId: entradaFiltrada._id,
        valor: valorCancelar || entradaFiltrada.valor,
        valorCancelar: valorCancelar,
        descricaoPagamento: entradaFiltrada.descricao,
        metodoPagamento: entradaFiltrada.metodoPagamento,
        usuarioEmissor: auth.userId,
        IUDCancelar: entradaFiltrada.documentoEletronico.entryName.replace(
          /\.xml$/,
          "",
        ),
        idDocumentoAnular: entradaFiltrada.documentoEletronico._id,
        IssueReasonCode: motivoCancelamento,
        nomeCliente: clienteData.nome,
        nifCliente: clienteData.nif,
        contactoCliente: clienteData.contacto,
        moradaCliente: clienteData.endereco,
        codigoPaisCliente: clienteData.pais.codigo,
        online: !documentoOriginalEmContingencia,
        emitirEmContingencia: documentoOriginalEmContingencia,
        ReasonTypeCode: dadosContingencia?.ReasonTypeCode,
        ReasonDescription: dadosContingencia?.ReasonDescription,
        clinica: {
          nif: clinica.clinica.nif,
          nomeFiscal: clinica.clinica.nomeFiscal,
          endereco: clinica.clinica.endereco,
          contacto: clinica.clinica.contacto,
          email: clinica.clinica.email,
        },
      };

      // MODO CONTINGÊNCIA: Abre diálogo para escolher motivo
      // (se documento original em contingência OU modo contingência ativo)
      if (
        (documentoOriginalEmContingencia || modoContingenciaAtivo) &&
        !dadosContingencia
      ) {
        setDadosContingenciaPendente({
          tipo: "NCE",
          entrada,
          motivoCancelamento,
          valorCancelar,
          dados: dadosCancelamento,
        });
        setDialogContingenciaOpen(true);
        stopLoading();
        return;
      }

      await executarEmissaoNCE(dadosCancelamento);
    } catch (err) {
      console.error("Erro ao emitir NCE:", err);
      toast.error("Erro ao emitir NCE");
    } finally {
      stopLoading();
    }
  };

  //Emitir RCE
  const emitirRCEHandler = async (idEntrada, receberEEmitir) => {
    startLoading();

    let dadosEmissao;
    try {
      const entradaFiltrada = entradas.find((en) => en._id === idEntrada);

      // Verificar se FTE original está em contingência
      const fteEmContingencia =
        entradaFiltrada.documentoEletronico?.emitidoEmContingencia === true;

      dadosEmissao = {
        clinicaId: clinicaId,
        tipoDocEletronico: "RCE",
        valor: entradaFiltrada.valor,
        usuarioEmissor: auth.userId,
        entradaId: idEntrada,
        online: true,
        metodoPagamento: entradaFiltrada.metodoPagamento,

        // Dados do cliente
        nomeCliente: entradaFiltrada.clienteFornecedor.nome,
        nifCliente: entradaFiltrada.clienteFornecedor.nif,
        contactoCliente: entradaFiltrada.clienteFornecedor.contacto,
        moradaCliente: entradaFiltrada.clienteFornecedor.endereco,
        codigoPaisCliente: entradaFiltrada.clienteFornecedor.pais.codigo,

        // Dados específicos do RCE
        IUDReceber: entradaFiltrada.documentoEletronico.entryName.replace(
          /\.xml$/,
          "",
        ),
        innerDocumentNumber: entradaFiltrada.documentoEletronico.nrDocumento,
        FTEId: entradaFiltrada.documentoEletronico._id,

        clinica: {
          nif: clinica.clinica.nif,
          nomeFiscal: clinica.clinica.nomeFiscal,
          endereco: clinica.clinica.endereco,
          contacto: clinica.clinica.contacto,
          email: clinica.clinica.email,
        },
      };

      // MODO CONTINGÊNCIA: Abre diálogo para escolher motivo
      // (se FTE original em contingência OU modo contingência ativo)
      if (fteEmContingencia || modoContingenciaAtivo) {
        setDadosContingenciaPendente({
          tipo: "RCE",
          idEntrada,
          receberEEmitir,
          dados: dadosEmissao,
        });
        setDialogContingenciaOpen(true);
        stopLoading();
        return;
      }

      await executarEmissaoRCE(dadosEmissao);
    } catch (err) {
      console.error("Erro ao emitir RCE:", err);
      toast.error("Erro ao emitir RCE");
    } finally {
      stopLoading();
    }
  };

  /////////////////////////////////////////////////////////////////////
  /* Só entradas. As linhas de parcelas deste ecrã não têm menu de ações, e
     por isso nunca chegavam aqui — o caminho das parcelas era código morto,
     e levava a designação escrita à mão em vez da descrição da parcela. */
  const gerarPdfFaturaEletronicaHandler = async (id) => {
    const dadosFiltrados = entradas.filter((e) => e.id === id)[0];

    showFatura({
      show: true,
      // Morada da unidade que EMITIU o documento, não da que está a imprimir.
      clinica: dadosImpressao(
        dadosClinica,
        dadosFiltrados.documentoEletronico?.estabelecimento,
      ),
      cliente: {
        nome:
          dadosFiltrados.cliente?.nome ||
          dadosFiltrados.clienteFornecedor?.nome,
        endereco:
          dadosFiltrados.cliente?.endereco ||
          dadosFiltrados.clienteFornecedor?.endereco,
        contacto:
          dadosFiltrados.cliente?.contacto ||
          dadosFiltrados.clienteFornecedor?.contacto,
        nif:
          dadosFiltrados.cliente?.nif || dadosFiltrados.clienteFornecedor?.nif,
      },
      metodoPagamento: dadosFiltrados.metodoPagamento,
      designacao: dadosFiltrados.descricao,
      valor: dadosFiltrados.documentoEletronico.valor,
      nrDocumento: dadosFiltrados.documentoEletronico.nrDocumento,
      dataDocumento: dadosFiltrados.documentoEletronico.authorizedDateTime,
      dataVencimento: dadosFiltrados.dataLimitePagamento,
      entryName: dadosFiltrados.documentoEletronico.entryName,
      serie: dadosFiltrados.documentoEletronico.serie,
      tipoDocumento: dadosFiltrados.documentoEletronico.tipoDocumento,
      emitidoEmContingencia:
        dadosFiltrados.documentoEletronico.emitidoEmContingencia,
      usuarioEmissor: dadosFiltrados.documentoEletronico.usuarioEmissor?.name,
    });
  };

  const gerarPdfRceHandler = async (id) => {
    let entradaFiltrada;

    entradaFiltrada = entradas.filter((e) => e.id === id)[0];
    showRce({
      show: true,
      clinica: dadosImpressao(
        dadosClinica,
        entradaFiltrada.faturaEReciboEletronicos?.rce?.estabelecimento,
      ),
      cliente: {
        nome: entradaFiltrada.clienteFornecedor.nome,
        endereco: entradaFiltrada.clienteFornecedor.endereco,
        contacto: entradaFiltrada.clienteFornecedor.contacto,
        nif: entradaFiltrada.clienteFornecedor.nif,
      },
      metodoPagamento: entradaFiltrada.metodoPagamento,
      dataPagamento: entradaFiltrada.dataPagamento,
      designacao: entradaFiltrada.descricao,
      valor: entradaFiltrada.faturaEReciboEletronicos.rce.valor,
      nrDocumento: entradaFiltrada.faturaEReciboEletronicos.rce.nrDocumento,
      dataDocumento:
        entradaFiltrada.faturaEReciboEletronicos.rce.authorizedDateTime,
      entryName: entradaFiltrada.faturaEReciboEletronicos.rce.entryName,
      serie: entradaFiltrada.faturaEReciboEletronicos.rce.serie,
      tipoDocumento: entradaFiltrada.faturaEReciboEletronicos.rce.tipoDocumento,
      emitidoEmContingencia:
        entradaFiltrada.faturaEReciboEletronicos.rce.emitidoEmContingencia,
      referencia: entradaFiltrada.faturaEReciboEletronicos.fte.entryName,
      usuarioEmissor:
        entradaFiltrada.faturaEReciboEletronicos.rce.usuarioEmissor?.name,
    });
  };

  const gerarPdfNCEEntrada = async (entradaId, parCancelamento) => {
    const entradaFiltrada = entradas.find((e) => e.id === entradaId);

    showFatura({
      show: true,
      clinica: dadosImpressao(
        dadosClinica,
        parCancelamento?.documentoCancelamento?.estabelecimento,
      ),
      cliente: {
        nome:
          entradaFiltrada.tipo === "reembolso"
            ? entradaFiltrada.cliente.nomeFiscal
            : entradaFiltrada.clienteFornecedor.nome,
        endereco:
          entradaFiltrada.tipo === "reembolso"
            ? entradaFiltrada.cliente.endereco
            : entradaFiltrada.clienteFornecedor.endereco,
        contacto:
          entradaFiltrada.tipo === "reembolso"
            ? entradaFiltrada.cliente.contacto
            : entradaFiltrada.clienteFornecedor.contacto,
        nif:
          entradaFiltrada.tipo === "reembolso"
            ? entradaFiltrada.cliente.nif
            : entradaFiltrada.clienteFornecedor.nif,
      },
      valor: parCancelamento.documentoCancelamento.valor,
      nrDocumento: parCancelamento.documentoCancelamento.nrDocumento,
      dataDocumento: parCancelamento.documentoCancelamento.dataEmissao,
      dataVencimento: null,
      entryName: parCancelamento.documentoCancelamento.entryName,
      serie: parCancelamento.documentoCancelamento.serie,
      tipoDocumento: parCancelamento.documentoCancelamento.tipoDocumento,
      emitidoEmContingencia:
        parCancelamento.documentoCancelamento.emitidoEmContingencia,
      usuarioEmissor:
        parCancelamento.documentoCancelamento.usuarioEmissor?.name,
      referencia: parCancelamento?.documento?.entryName,
      nrDocumentoAnulado: parCancelamento?.documento?.nrDocumento,
      tipoDocumentoAnulado: parCancelamento?.documento?.tipoDocumento,
      anoDocumentoAnulado: moment(
        parCancelamento?.documento?.authorizedDateTime,
      ).year(),
    });
  };

  const updateEntradas = (entradaRetornada, action, emit) => {
    if (action === "inserir") {
      const tempEntradas = [...entradas];
      const tempEntradasAbsolut = [...entradasAbsolut];
      const tempEntradasParaTextSearch = [...entradasParaTextSearch];

      tempEntradas.push(entradaRetornada);
      tempEntradasAbsolut.push(entradaRetornada);
      tempEntradasParaTextSearch.push(entradaRetornada);

      setEntradasAbsolut([...tempEntradasAbsolut]);
      setEntradasParaTextSearch([...tempEntradasParaTextSearch]);
      setEntradas([...tempEntradas]);
    } else if (action === "emitirFTEDireto") {
      // Não insere ainda, só emite. A inserção será feita quando o FTE voltar.
      emitirDocEletronico(entradaRetornada, null, "inserir");
    } else {
      // Atualizar
      setEntradas(
        entradas.map((e) =>
          e._id === entradaRetornada._id ? entradaRetornada : e,
        ),
      );
      setEntradasAbsolut(
        entradasAbsolut.map((e) =>
          e._id === entradaRetornada._id ? entradaRetornada : e,
        ),
      );
      setEntradasParaTextSearch(
        entradasParaTextSearch.map((e) =>
          e._id === entradaRetornada._id ? entradaRetornada : e,
        ),
      );
      stopLoading();
    }

    // Verificar emit no final, independente de inserir/atualizar
    if (emit === "emitirFTE") {
      emitirDocEletronico(entradaRetornada, null, "atualizar");
    }
  };

  const handleExportar = () => {
    const sheetData = rows.map((r) => {
      return {
        descricao: r.descricao
          ? r.descricao
          : `${r.nome}${r.nrParcela ? " - Parcela " + r.nrParcela : ""}`,
        cliente: r.cliente,
        valor: r.valor,
        tipo: r.tipo,
        estado: r.estado,
        data_Pagamento: r.dataPagamento
          ? moment(r.dataPagamento).format("DD-MM-YYYY")
          : "-",
        dataLimitePagamento: r.dataLimitePagamento
          ? moment(r.dataLimitePagamento).format("DD-MM-YYYY")
          : "-",
        metodoPagamento: r.metodoPagamento ? r.metodoPagamento : "-",
        categoria: r.categoria ? r.categoria : "-",
        caixa: r.caixa ? r.caixa : "-",
      };
    });

    generateExcelFile(
      `HistoricoReceitas ${moment().format("DD-MM-YYYY")}.xlsx`,
      "Receitas",
      sheetData,
    );
  };

  const handleFiltrar = (
    newParcelas,
    newEntradas,
    filtros,
    filtroCai,
    filtroCat,
    filtroMet,
    textoSearch,
    data,
  ) => {
    if (newParcelas) {
      setParcelas([...newParcelas]);
    }
    if (newEntradas) {
      setEntradas([...newEntradas]);
    }

    if (data === "modalFiltros") {
      setEntradasParaTextSearch([...newEntradas]);
      setParcelasParaTextSearch([...newParcelas]);
    }

    if (data !== "textSearch") {
      setFiltrosAplicados(filtros);
      setFiltroCaixa(filtroCai);
      setFiltroCategoria(filtroCat);
      setFiltroMetodoPagamento(filtroMet);
    }
    setFiltroTextoSearch(textoSearch);
  };

  const actionColumn = [
    {
      field: "inOrOut",
      headerName: "",
      width: 30,
      renderCell: (params) => {
        return (
          <>
            {params.row.tipo === "receita" &&
              params.row.status !== "CANCELADA" && (
                <CallReceivedIcon className="financeiro__container__cabecalho__totais--icon_div--receita" />
              )}

            {params.row.tipo === "entrada" && (
              <CallReceivedIcon className="financeiro__container__cabecalho__totais--icon_div--receita" />
            )}
          </>
        );
      },
    },
    {
      field: "dataCriacao",
      headerName: "Dt Criação",
      flex: 1,
      renderCell: (params) => {
        return (
          <div>
            {params.row.tipo === "receita" && <span>N/A</span>}
            {params.row.tipo === "entrada" && (
              <div className="receita__DataCriacao">
                {moment(params.row.dataCriacao).format("DD/MM/YYYY")}
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: "dataLimitePagamento",
      headerName: "Dt Vencimento",
      flex: 1,
      renderCell: (params) => {
        return (
          <div>
            {params.row.tipo === "receita" &&
              (params.row.parcelaPaga ? (
                <span>N/A</span>
              ) : (
                <span>
                  {moment(params.row.dataLimitePagamento).format("DD/MM/YYYY")}
                </span>
              ))}
            {params.row.tipo === "entrada" && (
              <div
                className={
                  params.row.entradaRecebida && params.row.dataLimitePagamento
                    ? "spanCellPago"
                    : !params.row.entradaRecebida &&
                        moment().isAfter(
                          moment(params.row.dataLimitePagamento),
                          "day",
                        )
                      ? "spanCellAtraso"
                      : ""
                }
              >
                {params.row.entradaRecebida && params.row.dataLimitePagamento
                  ? moment(params.row.dataLimitePagamento).format("DD/MM/YYYY")
                  : moment(params.row.dataLimitePagamento).format("DD/MM/YYYY")}
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: "data",
      headerName: "Dt Recebimento",
      flex: 1,
      renderCell: (params) => {
        return (
          <div>
            {params.row.tipo === "receita" &&
              (params.row.parcelaPaga ? (
                <span
                  className={
                    params.row.parcelaPaga &&
                    params.row.dataPagamento &&
                    params.row.status !== "CANCELADA"
                      ? "spanCellPago"
                      : !params.row.parcelaPaga &&
                          params.row.status !== "CANCELADA" &&
                          moment(params.row.dataLimitePagamento) < moment()
                        ? "spanCellAtraso"
                        : ""
                  }
                >
                  {params.row.parcelaPaga && params.row.dataPagamento
                    ? moment(params.row.dataPagamento).format("DD/MM/YYYY")
                    : moment(params.row.dataLimitePagamento).format(
                        "DD/MM/YYYY",
                      )}
                </span>
              ) : (
                <span>N/A</span>
              ))}

            {params.row.tipo === "entrada" && (
              <div
                className={
                  params.row.entradaRecebida && params.row.dataPagamento
                    ? "spanCellPago"
                    : !params.row.entradaRecebida &&
                        moment().isAfter(
                          moment(params.row.dataLimitePagamento),
                          "day",
                        )
                      ? "spanCellAtraso"
                      : ""
                }
              >
                {params.row.entradaRecebida && params.row.dataPagamento
                  ? moment(params.row.dataPagamento).format("DD/MM/YYYY")
                  : "N/A"}
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: "nome",
      headerName: "Nome",
      flex: 5,
      renderCell: (params) => {
        return (
          <>
            {params.row.tipo === "receita" && (
              <div className="cellDebitoNome">
                {/* A pastilha estava só no ramo das ENTRADAS, mais abaixo. As
                    parcelas passam por este outro ramo e ficavam sem ela — daí
                    parecer que só a HT2 tinha pastilha, quando na verdade só as
                    entradas a tinham, e quase todas as entradas eram de lá. */}
                {verTodasUnidades && (
                  <BadgeUnidade
                    estabelecimento={params.row.estabelecimento}
                    prefixo="Recebido em"
                  />
                )}{" "}
                <span
                  className={
                    params.row.parcelaPaga &&
                    params.row.dataPagamento &&
                    params.row.status !== "CANCELADA"
                      ? "spanCellPago"
                      : !params.row.parcelaPaga &&
                          params.row.status !== "CANCELADA" &&
                          moment(params.row.dataLimitePagamento) < moment()
                        ? "spanCellAtraso"
                        : ""
                  }
                >
                  {params.row.status === "CANCELADA"
                    ? "PARCELA " + params.row.status + " - "
                    : params.row.nome}{" "}
                  <Link
                    to={`/clientes/${params.row.idCliente}-debitos`}
                    className="link-cliente-receita"
                  >
                    {" "}
                    {params.row.cliente}
                  </Link>
                </span>
                {params.row.nrParcela && (
                  <Tooltip
                    title={`Parcelado em ${params.row.nrParcela[2]} vezes`}
                  >
                    <IconButton>
                      <span className="nrParcela">{params.row.nrParcela}</span>
                    </IconButton>
                  </Tooltip>
                )}
                <Tooltip title="Ver orçamento">
                  <IconButton
                    onClick={handleOpenModalProcedimentos.bind(
                      null,
                      params.row.orcamento._id,
                    )}
                  >
                    <ErrorIcon className="muiIconVerOrcamento" />
                  </IconButton>
                </Tooltip>
              </div>
            )}

            {params.row.tipo === "entrada" && (
              <div
                className={
                  "link-cliente-receita " + params.row.entradaRecebida &&
                  params.row.dataPagamento
                    ? "spanCellPago"
                    : !params.row.entradaRecebida &&
                        moment().isAfter(
                          moment(params.row.dataLimitePagamento),
                          "day",
                        )
                      ? "spanCellAtraso"
                      : ""
                }
              >
                {/* Só no consolidado. Quando se está a ver uma unidade, todas
                    as linhas são dela e a pastilha seria ruído repetido. */}
                {verTodasUnidades && (
                  <BadgeUnidade
                    estabelecimento={params.row.estabelecimento}
                    prefixo="Registado em"
                  />
                )}{" "}
                {params.row.descricao}
                {params.row.cliente && (
                  <>
                    {" - "}

                    {params.row.tipoEntrada === "reembolso" ? (
                      <Link
                        to={`/clientes/${params.row.cliente._id}-debitos`}
                        className="link-cliente-receita"
                      >
                        {" "}
                        {params.row.cliente.nome}
                      </Link>
                    ) : (
                      params.row.cliente.nome
                    )}
                  </>
                )}
              </div>
            )}
          </>
        );
      },
    },
    {
      field: "estado",
      headerName: "Pagamento",
      flex: 1.5,
      renderCell: (params) => {
        return (
          <>
            {params.row.tipo === "receita" &&
              params.row.orcamento.desconto ===
                params.row.orcamento.subtotal -
                  (params.row.orcamento.majoracao || 0) && (
                <span className="debitos__isento">Isenção</span>
              )}

            {params.row.tipo === "receita" &&
              params.row.orcamento.desconto !==
                params.row.orcamento.subtotal -
                  (params.row.orcamento.majoracao || 0) &&
              params.row.status !== "CANCELADA" && (
                <div className="cellDebitoEstado">
                  <span
                    className={`debitos__container__estado ${
                      params.row.estado === "Em atraso"
                        ? "debitos__container__estado--atraso"
                        : params.row.estado === "Pago"
                          ? "debitos__container__estado--pago"
                          : ""
                    }`}
                  >
                    {params.row.metodoPagamento
                      ? params.row.metodoPagamento
                      : params.row.estado}
                  </span>
                </div>
              )}

            {params.row.tipo === "entrada" && (
              <div className="cellDebitoEstado">
                <span
                  className={
                    "debitos__container__estado debitos__container__estado--pago"
                  }
                >
                  {params.row.metodoPagamento}
                </span>
              </div>
            )}
          </>
        );
      },
    },
    {
      field: "valor",
      headerName: "Valor",
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            {params.row.tipo === "receita" &&
              params.row.orcamento.desconto !==
                params.row.orcamento.subtotal -
                  (params.row.orcamento.majoracao || 0) && (
                <div className="cellAction" style={{ marginLeft: "auto" }}>
                  <span
                    className={`debitos__container__valor ${
                      params.row.estado === "Em atraso" &&
                      params.row.status !== "CANCELADA"
                        ? "debitos__container__valor--atraso"
                        : params.row.estado === "Pago" &&
                            params.row.status !== "CANCELADA"
                          ? "debitos__container__valor--pago"
                          : ""
                    }`}
                  >
                    {params.row.valor}
                  </span>
                </div>
              )}

            {params.row.tipo === "entrada" && (
              <span
                className={
                  params.row.entradaRecebida && params.row.dataPagamento
                    ? "spanCellPago"
                    : !params.row.entradaRecebida &&
                        moment().isAfter(
                          moment(params.row.dataLimitePagamento),
                          "day",
                        )
                      ? "spanCellAtraso"
                      : ""
                }
                style={{ marginLeft: "auto" }}
              >
                {params.row.valor}
              </span>
            )}
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "Estado",
      flex: 1.5,
      renderCell: (params) => {
        return (
          <div className="cellDebitoStatus">
            {params.row.estado === "Pago" && (
              <span
                className={
                  params.row.orcamento?.desconto ===
                  params.row.orcamento.subtotal -
                    (params.row.orcamento.majoracao || 0)
                    ? "debitos__container__receber debitos__container__receber--isento"
                    : "debitos__container__receber debitos__container__receber--pago"
                }
              >
                <Tooltip
                  title={
                    params.row.orcamento?.desconto ===
                    params.row.orcamento.subtotal -
                      (params.row.orcamento.majoracao || 0)
                      ? "Parcela Isenta de Pagamento"
                      : `Parcela recebida ${
                          params.row.recebidoPor
                            ? `por ${params.row.recebidoPor}`
                            : ""
                        }${
                          params.row.dataRecebimento
                            ? " aos " + params.row.dataRecebimento
                            : ""
                        }`
                  }
                >
                  <CheckCircleIcon />
                </Tooltip>
              </span>
            )}

            {params.row.tipo === "entrada" && params.row.entradaRecebida && (
              <span className="debitos__container__receber debitos__container__receber--pago">
                <Tooltip
                  title={`Entrada Recebida ${
                    params.row.recebidoPor
                      ? `por ${params.row.recebidoPor}`
                      : ""
                  }${
                    params.row.dataRecebimento
                      ? " aos " + params.row.dataRecebimento
                      : ""
                  }`}
                >
                  <CheckCircleIcon />
                </Tooltip>
              </span>
            )}

            {params.row.nrRecibo && (
              <span className="debitos__container__receber debitos__container__receber--reciboInterno">
                <Tooltip title="Recibo Interno">
                  <ArticleOutlinedIcon />
                </Tooltip>
              </span>
            )}

            {/* Tooltip para documento eletronico e nr de cancelamentos efetuados */}
            {/* {params.row.documentoEletronico?.succeeded === true && (
              <span className="debitos__container__receber debitos__container__receber--pago">
                <Tooltip
                  title={
                    <div style={{ whiteSpace: "pre-line" }}>
                      {`${
                        params.row.documentoEletronico?.tipoDocumento
                      } emitido ${
                        params.row.emitidoPor
                          ? `por ${params.row.emitidoPor}`
                          : ""
                      }${
                        params.row.dataEmissao
                          ? ` aos ${params.row.dataEmissao}`
                          : ""
                      }.`}
                      {params.row?.cancelamentosDocumentosEletronicos?.length >
                        0 &&
                        params.row?.cancelamentosDocumentosEletronicos.filter(
                          (item) =>
                            item.documentoCancelamento.succeeded === true
                        ).length > 0 && (
                          <>
                            <br />
                            {`${
                              params.row?.cancelamentosDocumentosEletronicos.filter(
                                (item) =>
                                  item.documentoCancelamento.succeeded === true
                              ).length
                            } cancelamentos efetuados.`}
                            {params.row.cancelamentosDocumentosEletronicos.map(
                              (c, index) =>
                                c.documentoCancelamento.succeeded === true && (
                                  <React.Fragment key={index}>
                                    <br />
                                    {c.documento.entryName.split(".")[0]}
                                  </React.Fragment>
                                )
                            )}
                          </>
                        )}
                    </div>
                  }
                >
                  <div className="debitos__container__receber debitos__container__receber--pago">
                    <ArticleOutlinedIcon />
                  </div>
                </Tooltip>
              </span>
            )} */}

            {params.row.documentoEletronico?.succeeded === true &&
              !params.row.faturaEReciboEletronicos?.fte && (
                <span
                  className={
                    params.row.documentoEletronico?.emitidoEmContingencia
                      ? "debitos__container__receber debitos__container__receber--contingencia"
                      : params.row.documentoEletronico?.tipoDocumento === "FTE"
                        ? "debitos__container__receber debitos__container__receber--fte"
                        : "debitos__container__receber debitos__container__receber--pago"
                  }
                >
                  <Tooltip
                    title={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {/* NOVO: Texto diferente para contingência */}
                        {params.row.documentoEletronico
                          ?.emitidoEmContingencia ? (
                          <>
                            {`⚠️ ${params.row.documentoEletronico?.tipoDocumento} emitido em CONTINGÊNCIA`}
                            <br />
                            {`Emitido offline em: ${
                              params.row.dataEmissao || "N/A"
                            }`}
                            {params.row.documentoEletronico
                              ?.motivoContingencia && (
                              <>
                                <br />
                                {`Motivo: ${params.row.documentoEletronico.motivoContingencia}`}
                              </>
                            )}
                            <br />
                            <br />
                            {`Documento aguardando transmissão para E-fatura.`}
                          </>
                        ) : (
                          // Texto normal para documentos online
                          <>
                            {`${
                              params.row.documentoEletronico?.tipoDocumento +
                              " " +
                              params.row.documentoEletronico?.nrDocumento
                            } emitido ${
                              params.row.emitidoPor
                                ? `por ${params.row.emitidoPor}`
                                : ""
                            }${
                              params.row.dataEmissao
                                ? ` aos ${params.row.dataEmissao}`
                                : ""
                            }.`}
                            {params.row?.cancelamentosDocumentosEletronicos
                              ?.length > 0 &&
                              params.row?.cancelamentosDocumentosEletronicos.filter(
                                (item) =>
                                  item.documentoCancelamento.succeeded === true,
                              ).length > 0 && (
                                <>
                                  <br />
                                  {`${
                                    params.row?.cancelamentosDocumentosEletronicos.filter(
                                      (item) =>
                                        item.documentoCancelamento.succeeded ===
                                        true,
                                    ).length
                                  } cancelamentos efetuados.`}
                                  {params.row.cancelamentosDocumentosEletronicos.map(
                                    (c, index) =>
                                      c.documentoCancelamento.succeeded ===
                                        true && (
                                        <React.Fragment key={index}>
                                          <br />
                                          {c.documento.entryName.split(".")[0]}
                                        </React.Fragment>
                                      ),
                                  )}
                                </>
                              )}
                          </>
                        )}
                      </div>
                    }
                  >
                    <div className="debitos__container__receber debitos__container__receber--pago">
                      <ArticleOutlinedIcon />
                    </div>
                  </Tooltip>
                </span>
              )}

            {/* Icones e tooltip para erros em cancelamento */}
            {params.row?.cancelamentosDocumentosEletronicos?.length > 0 &&
              params.row?.cancelamentosDocumentosEletronicos[
                params.row?.cancelamentosDocumentosEletronicos.length - 1
              ].documentoCancelamento?.succeeded === false && (
                <span className="debitos__container__receber debitos__container__receber--atraso">
                  <Tooltip
                    title={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {`Cancelamento com erro(s).`}
                        {params.row?.cancelamentosDocumentosEletronicos[
                          params.row?.cancelamentosDocumentosEletronicos
                            .length - 1
                        ].documentoCancelamento?.messages?.length > 0 && (
                          <>
                            {params.row?.cancelamentosDocumentosEletronicos[
                              params.row?.cancelamentosDocumentosEletronicos
                                .length - 1
                            ].documentoCancelamento?.messages.map(
                              (m, index) => (
                                <React.Fragment key={index}>
                                  <br />
                                  <br />
                                  {m.description}
                                </React.Fragment>
                              ),
                            )}
                          </>
                        )}
                      </div>
                    }
                  >
                    <ArticleOutlinedIcon sx={{ cursor: "help" }} />
                  </Tooltip>
                </span>
              )}

            {params.row.documentoEletronico?.succeeded === false && (
              <span className="debitos__container__receber debitos__container__receber--atraso">
                <Tooltip
                  title={
                    <div style={{ whiteSpace: "pre-line" }}>
                      {`${params.row.documentoEletronico?.tipoDocumento} com erro.`}
                      {params.row?.documentoEletronico?.messages?.length >
                        0 && (
                        <>
                          {params.row.documentoEletronico.messages.map(
                            (m, index) => (
                              <React.Fragment key={index}>
                                <br />
                                <br />
                                {m.description}
                              </React.Fragment>
                            ),
                          )}
                        </>
                      )}
                    </div>
                  }
                >
                  <ArticleOutlinedIcon sx={{ cursor: "help" }} />
                </Tooltip>
              </span>
            )}

            {/* {params.row.faturaEReciboEletronicos?.rce?.succeeded === true && (
              <Tooltip
                title={`RCE emitido ${
                  params.row.emitidoPor
                    ? `por ${params.row.rceEmitidoPor}${
                        params.row.dataEmissaoRce
                          ? ` aos ${params.row.dataEmissaoRce}`
                          : ""
                      } `
                    : ""
                }.`}
              >
                <div className="debitos__container__receber debitos__container__receber--pago">
                  <ArticleOutlinedIcon />
                </div>
              </Tooltip>
            )} */}

            {params.row.faturaEReciboEletronicos?.fte?.succeeded === true && (
              <Tooltip
                title={`FTE ${
                  params.row.faturaEReciboEletronicos.fte?.nrDocumento || ""
                } emitido${
                  params.row.fteEmitidoPor
                    ? ` por ${params.row.fteEmitidoPor}`
                    : ""
                }${
                  params.row.dataEmissaoFte
                    ? ` aos ${params.row.dataEmissaoFte}`
                    : ""
                }.`}
              >
                <div className="debitos__container__receber debitos__container__receber--fte">
                  <ArticleOutlinedIcon />
                </div>
              </Tooltip>
            )}

            {params.row.faturaEReciboEletronicos?.fte?.succeeded === false && (
              <span className="debitos__container__receber debitos__container__receber--atraso">
                <Tooltip
                  title={
                    <div style={{ whiteSpace: "pre-line" }}>
                      {`FTE com erro.`}
                      {params.row?.faturaEReciboEletronicos?.fte?.messages
                        ?.length > 0 && (
                        <>
                          {params.row.faturaEReciboEletronicos.fte.messages.map(
                            (m, index) => (
                              <React.Fragment key={index}>
                                <br />
                                <br />
                                {m.description}
                              </React.Fragment>
                            ),
                          )}
                        </>
                      )}
                    </div>
                  }
                >
                  <ArticleOutlinedIcon sx={{ cursor: "help" }} />
                </Tooltip>
              </span>
            )}

            {params.row.faturaEReciboEletronicos?.rce?.succeeded === true && (
              <Tooltip
                title={
                  params.row.faturaEReciboEletronicos.rce
                    ?.emitidoEmContingencia ? (
                    <div style={{ whiteSpace: "pre-line" }}>
                      {`⚠️ RCE ${
                        params.row.faturaEReciboEletronicos.rce?.nrDocumento ||
                        ""
                      } emitido em CONTINGÊNCIA`}
                      <br />
                      {`Emitido offline em: ${
                        params.row.dataEmissaoRce || "N/A"
                      }`}
                      {params.row.faturaEReciboEletronicos.rce
                        ?.motivoContingencia && (
                        <>
                          <br />
                          {`Motivo: ${params.row.faturaEReciboEletronicos.rce.motivoContingencia}`}
                        </>
                      )}
                      <br />
                      <br />
                      {`Documento aguardando transmissão para E-fatura.`}
                    </div>
                  ) : (
                    // Com o número, como na FRE, na TVE e na FTE — é por ele
                    // que o recibo se identifica ao telefone e na e-fatura.
                    `RCE ${
                      params.row.faturaEReciboEletronicos.rce?.nrDocumento ?? ""
                    } emitido ${
                      params.row.rceEmitidoPor
                        ? `por ${params.row.rceEmitidoPor}${
                            params.row.dataEmissaoRce
                              ? ` aos ${params.row.dataEmissaoRce}`
                              : ""
                          }`
                        : ""
                    }.`
                  )
                }
              >
                <div
                  className={
                    params.row.faturaEReciboEletronicos.rce
                      ?.emitidoEmContingencia
                      ? "debitos__container__receber debitos__container__receber--contingencia"
                      : "debitos__container__receber debitos__container__receber--pago"
                  }
                >
                  <ArticleOutlinedIcon />
                </div>
              </Tooltip>
            )}

            {params.row.faturaEReciboEletronicos?.rce?.succeeded === false && (
              <span className="debitos__container__receber debitos__container__receber--atraso">
                <Tooltip
                  title={
                    <div style={{ whiteSpace: "pre-line" }}>
                      {`RCE emitido ${
                        params.row.emitidoPor
                          ? `por ${params.row.rceEmitidoPor}${
                              params.row.dataEmissao
                                ? ` aos ${params.row.dataEmissao}`
                                : ""
                            }`
                          : ""
                      } - com erro.`}
                      {params.row?.faturaEReciboEletronicos?.rce?.messages
                        ?.length > 0 && (
                        <>
                          {params.row.faturaEReciboEletronicos.rce.messages.map(
                            (m, index) => (
                              <React.Fragment key={index}>
                                <br />
                                <br />
                                {m.description}
                              </React.Fragment>
                            ),
                          )}
                        </>
                      )}
                    </div>
                  }
                >
                  <ArticleOutlinedIcon sx={{ cursor: "help" }} />
                </Tooltip>
              </span>
            )}

            {params.row.cancelamentosRecibosEletronicos?.length > 0 &&
              params.row.cancelamentosRecibosEletronicos[
                params.row.cancelamentosRecibosEletronicos?.length - 1
              ]?.documentoCancelamento?.succeeded === false && (
                <span className="debitos__container__receber debitos__container__receber--atraso">
                  <Tooltip
                    title={
                      <React.Fragment>
                        {
                          params.row.cancelamentosRecibosEletronicos[
                            params.row.cancelamentosRecibosEletronicos?.length -
                              1
                          ]?.documentoCancelamento?.tipoDocumento
                        }{" "}
                        com erro:
                        <br />
                        {params.row.cancelamentosRecibosEletronicos[
                          params.row.cancelamentosRecibosEletronicos.length - 1
                        ].documentoCancelamento.messages.map((m, index) => (
                          <React.Fragment key={index}>
                            {index > 0 && (
                              <>
                                <br />
                                <br />
                              </>
                            )}
                            {m.description}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    }
                  >
                    <ArticleOutlinedIcon sx={{ cursor: "help" }} />
                  </Tooltip>
                </span>
              )}

            {params.row.cancelamentosDocumentosEletronicos?.filter(
              (can) => can.documentoCancelamento?.succeeded === true,
            ).length > 0 && (
              <span className="debitos__container__receber debitos__container__receber--atraso">
                <Tooltip
                  title={
                    <React.Fragment>
                      Essa{" "}
                      {params.row.tipo === "entrada" ? "entrada" : "parcela"}{" "}
                      tem {params.row.cancelamentosDocumentosEletronicos.length}{" "}
                      {params.row.cancelamentosDocumentosEletronicos.length > 1
                        ? "cancelamentos"
                        : "cancelamento"}
                      :
                      <br />
                      <br />
                      {params.row.cancelamentosDocumentosEletronicos.map(
                        (d, index) => (
                          <React.Fragment key={index}>
                            {index > 0 && (
                              <>
                                <br />
                              </>
                            )}
                            {"* " +
                              d.documentoCancelamento.entryName.split(
                                ".xml",
                              )[0]}
                          </React.Fragment>
                        ),
                      )}
                    </React.Fragment>
                  }
                >
                  <CancelIcon sx={{ cursor: "help" }} />
                </Tooltip>
              </span>
            )}
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "Ações",
      flex: 1,
      renderCell: (params) => {
        /* Uma entrada de outra unidade vê-se mas não se mexe: nada de receber,
           editar, emitir ou anular. Ler e imprimir continua livre — a
           informação é da empresa, é a operação que pertence à unidade.

           As opções bloqueadas ficam ACINZENTADAS, não desaparecem: quem
           procura "cancelar recebimento" e não o encontra pensa que é avaria
           ou que perdeu a permissão. Acinzentada, sabe que existe e porque não
           pode — a razão está no `title`.

           Atenção ao converter: o `podeGerirEntrada` sai da condição de
           renderização e passa a escolher ENTRE as duas versões. As restantes
           condições (permissões, estado do documento, entrada recebida)
           continuam a esconder, porque aí a opção não se aplica de todo. */
        const podeGerirEntrada = podeAlterarRegisto(
          params.row.estabelecimento,
          auth,
        );
        const motivoUnidade = podeGerirEntrada
          ? undefined
          : motivoBloqueioUnidade(params.row.estabelecimento);

        /* Versão inerte de uma opção do menu, com a razão no title. */
        const opcaoBloqueada = (texto, icone) => (
          <div
            className="popOverMenu--option popOverMenu--option--desativada"
            title={motivoUnidade}
          >
            <span>{texto}</span>
            {icone}
          </div>
        );

        let content;
        if (params.row.tipo === "entrada") {
          content = (
            <div className="dots__menu__popup">
              {/* Sem isto, as opções simplesmente somem e parece avaria. */}
              {!podeGerirEntrada && (
                <div className="popOverMenu--option" style={{ cursor: "default" }}>
                  <SeloSoConsulta
                    estabelecimento={params.row.estabelecimento}
                  />
                </div>
              )}

              {/* VER ENTRADA */}
              <div
                className="popOverMenu--option"
                onClick={verEntradaHandler.bind(null, params.row.id)}
              >
                <span>Ver</span>
                <RemoveRedEyeIcon className="popOverMenu--option__icon" />
              </div>
              {/* EDITAR uma entrada JÁ RECEBIDA: só a caixa, a descrição e a
                  observação, com motivo — ver `ModalCorrigirCaixa`. A edição
                  normal, logo abaixo, é para as que ainda não foram recebidas
                  e muda tudo. */}
              {params.row.entradaRecebida &&
                podeCorrigirCaixa(auth) &&
                (podeGerirEntrada ? (
                  <div
                    className="popOverMenu--option"
                    onClick={() => setCorrigirCaixa(params.row.id)}
                  >
                    <span>Editar</span>
                    <EditIcon className="popOverMenu--option__icon" />
                  </div>
                ) : (
                  opcaoBloqueada(
                    "Editar",
                    <EditIcon className="popOverMenu--option__icon" />,
                  )
                ))}

              {/* EDITAR ENTRADA - apenas entradas que não possuem documento fiscal, cujo envio resultou em erro ou que nao estao pagas, não pode editar um documento com um envio de nce com erro*/}
              {auth.perm.includes("u-ent") &&
                params.row.tipoEntrada !== "reembolso" &&
                (!params.row.documentoEletronico ||
                  params.row.documentoEletronico?.succeeded === false) &&
                !params.row.entradaRecebida &&
                (params.row.cancelamentosDocumentosEletronicos?.length === 0 ||
                  (params.row.cancelamentosDocumentosEletronicos?.length > 0 &&
                    params.row.cancelamentosDocumentosEletronicos[
                      params.row.cancelamentosDocumentosEletronicos?.length - 1
                    ]?.documentoCancelamento?.succeeded === true)) &&
                (podeGerirEntrada ? (
                  <div
                    className="popOverMenu--option"
                    onClick={editarEntradaHandler.bind(null, params.row.id)}
                  >
                    <span>Editar</span>
                    <EditIcon className="popOverMenu--option__icon" />
                  </div>
                ) : (
                  opcaoBloqueada(
                    "Editar",
                    <EditIcon className="popOverMenu--option__icon" />,
                  )
                ))}

              {/* GERAR PDF FTE - se existe documento eletronico e foi bem sucedido */}
              {auth.perm.includes("u-ent") &&
                params.row.documentoEletronico?.succeeded && (
                  <div
                    className="popOverMenu--option"
                    onClick={gerarPdfFaturaEletronicaHandler.bind(
                      null,
                      params.row.id,
                    )}
                  >
                    <span>
                      Gerar PDF {params.row.documentoEletronico?.tipoDocumento}
                    </span>
                    <ArticleOutlinedIcon className="popOverMenu--option__icon" />
                  </div>
                )}

              {/* GERAR PDF RCE - se existe RCE e foi bem sucedido */}
              {auth.perm.includes("u-ent") &&
                params.row.faturaEReciboEletronicos?.rce?.succeeded &&
                params.row.tipoEntrada !== "reembolso" && (
                  <div
                    className="popOverMenu--option"
                    onClick={gerarPdfRceHandler.bind(
                      null,
                      params.row.id,
                      "entrada",
                    )}
                  >
                    <span>Gerar PDF RCE</span>
                    <ArticleOutlinedIcon className="popOverMenu--option__icon" />
                  </div>
                )}

              {/* EMITIR FTE - Não pode existir documento eletronico enviado com ou sem erro, não pode existir cancelamento com erro e a entrada não pode estar paga*/}
              {auth.perm.includes("u-ent") &&
                (!params.row.documentoEletronico ||
                  params.row.documentoEletronico?.succeeded === false) &&
                (params.row.cancelamentosDocumentosEletronicos?.length === 0 ||
                  (params.row.cancelamentosDocumentosEletronicos?.length > 0 &&
                    params.row.cancelamentosDocumentosEletronicos[
                      params.row.cancelamentosDocumentosEletronicos?.length - 1
                    ]?.documentoCancelamento?.succeeded === true)) &&
                !params.row.entradaRecebida &&
                params.row.tipoEntrada !== "reembolso" &&
                (podeGerirEntrada ? (
                  <Popconfirm
                    title="Fatura Eletrónica - FTE"
                    description={`Confirma a emissão${
                      modoContingenciaAtivo ? " em CONTINGÊNCIA" : ""
                    }?`}
                    icon={<ArticleOutlinedIcon style={{ color: "green" }} />}
                    okText="Sim"
                    cancelText="Não"
                    onConfirm={emitirDocEletronico.bind(
                      null,
                      null,
                      params.row.id,
                      "atualizar",
                    )}
                  >
                    <div className="popOverMenu--option">
                      <span>
                        Emitir FTE{modoContingenciaAtivo && " (Contingência)"}
                      </span>
                      <ArticleOutlinedIcon className="popOverMenu--option__icon" />
                    </div>
                  </Popconfirm>
                ) : (
                  opcaoBloqueada(
                    `Emitir FTE${
                      modoContingenciaAtivo ? " (Contingência)" : ""
                    }`,
                    <ArticleOutlinedIcon className="popOverMenu--option__icon" />,
                  )
                ))}

              {/* Emitir documentoCancelamento - apenas para ftes, caso o documento enviado obteve sucesso e se caso houver um envio de NCE, esse foi bem sucedido */}
              {auth.perm.includes("u-ent") &&
                !params.row.entradaRecebida &&
                params.row.documentoEletronico?.succeeded === true &&
                !params.row.nrRecibo &&
                params.row.tipoEntrada !== "reembolso" &&
                (podeGerirEntrada ? (
                  <Popconfirm
                    title="Nota de Crédito - NCE"
                    description={`Pretende cancelar a Fatura com a emissão de uma nota de crédito?`}
                    icon={<ErrorIcon style={{ color: "red" }} />}
                    okText="Sim"
                    cancelText="Não"
                    onConfirm={handleBeforeNCEEntrada.bind(null, params.row.id)}
                  >
                    <div className="popOverMenu--option">
                      <span>Anular Fatura</span>
                      <ArticleOutlinedIcon className="popOverMenu--option__icon" />
                    </div>
                  </Popconfirm>
                ) : (
                  opcaoBloqueada(
                    "Anular Fatura",
                    <ArticleOutlinedIcon className="popOverMenu--option__icon" />,
                  )
                ))}

              {/* Emitir RCE - se a entrada estiver recebida e não houver nenhum erro nem no documento fiscal, no recibos eletronicos. (PENSAR EM CASO DE ERRO NO CANCELAMENTO) */}
              {auth.perm.includes("u-ent") &&
                params.row.entradaRecebida &&
                params.row.tipoEntrada !== "reembolso" &&
                params.row.documentoEletronico?.succeeded === true &&
                !params.row.faturaEReciboEletronicos?.rce?.succeeded === true &&
                (podeGerirEntrada ? (
                  <Popconfirm
                    title="Recibo Eletrónico - RCE"
                    description={`Confirma emissão do Recibo Eletrónico${
                      modoContingenciaAtivo ? " em CONTINGÊNCIA" : ""
                    }?`}
                    icon={<ErrorIcon style={{ color: "green" }} />}
                    okText="Sim"
                    cancelText="Não"
                    onConfirm={emitirRCEHandler.bind(null, params.row.id, null)}
                  >
                    <div className="popOverMenu--option">
                      <span>
                        Emitir RCE{modoContingenciaAtivo && " (Contingência)"}
                      </span>
                      <ArticleOutlinedIcon className="popOverMenu--option__icon" />
                    </div>
                  </Popconfirm>
                ) : (
                  opcaoBloqueada(
                    `Emitir RCE${
                      modoContingenciaAtivo ? " (Contingência)" : ""
                    }`,
                    <ArticleOutlinedIcon className="popOverMenu--option__icon" />,
                  )
                ))}

              {/* Comprovativo */}
              {auth.perm.includes("r-ent") &&
                params.row.comprovativo &&
                params.row.comprovativo.ficheiro && (
                  <a
                    href={`${process.env.REACT_APP_BACKEND_LINK}/${params.row.comprovativo.ficheiro}`}
                    download
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="popOverMenu--option">
                      <span>Baixar Comprovativo</span>
                      <DownloadIcon className="popOverMenu--option__icon" />
                    </div>
                  </a>
                )}

              {/*CANCELAR RECEBIMENTO 1 - apenas para FTES, caso a entrada estiver paga, o documento enviado obteve sucesso e se caso houver um envio de NCE, esse foi bem sucedido */}
              {auth.perm.includes("u-ent") &&
                params.row.entradaRecebida &&
                params.row.tipoEntrada !== "reembolso" &&
                (podeGerirEntrada ? (
                  <Popconfirm
                    title="Cancelar Recebimento"
                    description={`Pretende cancelar o recebimento da entrada - ${
                      params.row.descricao
                    } ${
                      params.row.faturaEReciboEletronicos?.rce?.succeeded ===
                      true
                        ? " e anular o Recibo Eletrónico"
                        : ""
                    }?`}
                    icon={<ErrorIcon style={{ color: "red" }} />}
                    okText="Sim"
                    cancelText="Não"
                    onConfirm={handleBeforeCancelarRecebimentoEntrada.bind(
                      null,
                      params.row.id,
                      params.row.faturaEReciboEletronicos?.rce?.succeeded ===
                        true
                        ? true
                        : false, //Enviar NCE caso houver um fte enviado
                    )}
                  >
                    <div className="popOverMenu--option">
                      <span>Cancelar recebimento</span>
                      <SettingsBackupRestoreIcon className="popOverMenu--option__icon" />
                    </div>
                  </Popconfirm>
                ) : (
                  opcaoBloqueada(
                    "Cancelar recebimento",
                    <SettingsBackupRestoreIcon className="popOverMenu--option__icon" />,
                  )
                ))}

              {/* GERAR PDF NCE - para entradas com cancelamentos */}
              {auth.perm.includes("u-ent") &&
                params.row?.cancelamentosDocumentosEletronicos?.length > 0 &&
                params.row?.cancelamentosDocumentosEletronicos
                  .filter(
                    (can) => can.documentoCancelamento?.succeeded === true,
                  )
                  .map((can, index) => (
                    <div
                      className="popOverMenu--option"
                      onClick={gerarPdfNCEEntrada.bind(
                        null,
                        params.row.id,
                        can,
                      )}
                      key={"pdfNce" + index}
                    >
                      <span>
                        Gerar PDF NCE {can.documentoCancelamento.nrDocumento}
                      </span>
                      <ArticleOutlinedIcon
                        className="popOverMenu--option__icon"
                        sx={{ color: "crimson" }}
                      />
                    </div>
                  ))}

              {/* DESATIVAR ENTRADA -  se não houver nenum tipo de documento fiscal com ou sem erro e a entrada não estiver recebida */}
              {!params.row.documentoEletronico?.succeeded &&
                // !params.row.faturaEReciboEletronicos?.rce?.succeeded &&
                !params.row.entradaRecebida &&
                auth.perm.includes("d-ent") &&
                params.row.tipoEntrada !== "reembolso" &&
                (podeGerirEntrada ? (
                  <Popconfirm
                    title="Desativar Entrada"
                    description={`Pretende desativar a entrada - ${params.row.descricao}?`}
                    icon={<ErrorIcon style={{ color: "red" }} />}
                    okText="Sim"
                    cancelText="Não"
                    onConfirm={desativarEntradaHandler.bind(
                      null,
                      params.row.id,
                    )}
                  >
                    <div className="popOverMenu--option">
                      <span>Desativar</span>
                      <DeleteIcon className="popOverMenu--option__icon" />
                    </div>
                  </Popconfirm>
                ) : (
                  opcaoBloqueada(
                    "Desativar",
                    <DeleteIcon className="popOverMenu--option__icon" />,
                  )
                ))}
            </div>
          );
        }

        return (
          <>
            {/* RECEBER - Entradas nao pagas */}
            {params.row.tipo === "entrada" &&
              !params.row.entradaRecebida &&
              params.row.documentoEletronico?.succeeded &&
              auth.perm.includes("u-ent") &&
              (podeGerirEntrada ? (
                <span
                  className={`debitos__container__receber ${
                    params.row.estado === "Em atraso" &&
                    "debitos__container__receber--atraso"
                  }`}
                  onClick={handleOpenModalReceberEntrada.bind(
                    null,
                    params.row.id,
                  )}
                >
                  Receber
                </span>
              ) : (
                /* A entrada já tem FTE emitida pela outra unidade, e o recibo
                   tem de sair pelo mesmo LED. Fica visível e acinzentado, com
                   a razão no `title`. */
                <span
                  className="debitos__container__receber debitos__container__receber--bloqueada"
                  title={motivoUnidade}
                >
                  Receber
                </span>
              ))}

            {content && (
              <Popover content={content} trigger="click" placement="bottom">
                <div className="dots__menu">
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                </div>
              </Popover>
            )}
          </>
        );
      },
    },
  ];

  const validarDadosCliente = (cliente) => {
    if (!cliente.nif) {
      return { valido: false, erro: "O cliente não possui um nif" };
    }

    if (!cliente.nome?.trim()) {
      return { valido: false, erro: "O cliente não possui um nome!" };
    }

    if (!cliente.contacto?.trim()) {
      return {
        valido: false,
        erro: "O cliente não possui um número de telefone",
      };
    }

    if (!cliente.endereco?.trim()) {
      return { valido: false, erro: "O cliente não possui um endereço" };
    }

    if (!cliente.pais) {
      return { valido: false, erro: "O cliente não possui um pais" };
    }

    return { valido: true };
  };

  // Handlers do Dialog de Contingência
  const handleDialogContingenciaClose = () => {
    setDialogContingenciaOpen(false);
    setDadosContingenciaPendente(null);
    setMotivoContingenciaSelecionado(1);
    setDescricaoContingenciaOutro("");
    stopLoading();
  };

  const handleConfirmarContingencia = async () => {
    if (!dadosContingenciaPendente) return;

    setDialogContingenciaOpen(false);
    startLoading();

    try {
      const motivoSelecionado = MOTIVOS_CONTINGENCIA.find(
        (m) => m.codigo === motivoContingenciaSelecionado,
      );

      const dadosComContingencia = {
        ...dadosContingenciaPendente.dados,
        emitirEmContingencia: true,
        ReasonTypeCode: motivoContingenciaSelecionado,
        ReasonDescription:
          motivoContingenciaSelecionado === 0
            ? descricaoContingenciaOutro
            : motivoSelecionado?.label,
      };

      // Executa função apropriada
      if (dadosContingenciaPendente.tipo === "FTE") {
        await executarEmissaoFTE(
          dadosComContingencia,
          dadosContingenciaPendente.operacao,
        );
      } else if (dadosContingenciaPendente.tipo === "RCE") {
        await executarEmissaoRCE(dadosComContingencia);
      } else if (dadosContingenciaPendente.tipo === "NCE") {
        await executarEmissaoNCE(dadosComContingencia);
      }

      toast.success("Documento emitido em CONTINGÊNCIA.");
    } catch (err) {
      console.error("Erro ao emitir em contingência:", err);
      toast.error("Erro ao emitir documento em contingência");
    } finally {
      setDadosContingenciaPendente(null);
      setMotivoContingenciaSelecionado(1);
      setDescricaoContingenciaOutro("");
      stopLoading();
    }
  };

  return (
    <div className="financeiro__container caixa">
      {/* De que unidade são estes dados. Escolher aqui refaz o pedido. */}
      <SeletorUnidadeDados valor={unidadeDados} onChange={trocarUnidade} />

      <div className="financeiro__adicionarEFiltros">
        <FiltrosReceitas
          parcelasAbsolut={parcelasAbsolut}
          entradasAbsolut={entradasAbsolut}
          entradasParaTextSearch={entradasParaTextSearch}
          parcelasParaTextSearch={parcelasParaTextSearch}
          handleFiltrar={handleFiltrar}
          handleExportar={handleExportar}
          filtrosAplicados={filtrosAplicados}
          filtroCaixa={filtroCaixa}
          filtroCategoria={filtroCategoria}
          filtroMetodoPagamento={filtroMetodoPagamento}
          filtroTextoSearch={filtroTextoSearch}
          clinicaId={clinicaId}
          auth={auth}
          fetchContasCorrentesEntrada={fetchContasCorrentesEntrada}
        />

        <div>
          {auth.perm.includes("c-ent") && (
            <Button
              variant="contained"
              color="success"
              id="basic-button"
              onClick={(e) => setOpenModal("entrada")}
            >
              + Adicionar Entrada
            </Button>
          )}
        </div>
      </div>

      <div className="financeiro__container__cabecalho">
        <div className="financeiro__container__cabecalho__totais">
          <div className="financeiro__container__cabecalho__totais--recebido">
            <div className="financeiro__container__cabecalho__totais__firstContainer financeiro__container__cabecalho__totais__firstContainer--recebido">
              <div className="financeiro__container__cabecalho__totais--icon_div">
                <span className="financeiro__container__cabecalho__totais--titulos">
                  Total Recebido
                </span>
              </div>
              <div className="financeiro__container__cabecalho__totais--texto">
                <span className="financeiro__container__cabecalho__totais--recebido--valor_principal">
                  {financialData.totalRecebido}$00
                </span>
              </div>
            </div>
          </div>

          <div className="financeiro__container__cabecalho__totais--saldo">
            <div className="financeiro__container__cabecalho__totais__firstContainer financeiro__container__cabecalho__totais__firstContainer--saldo">
              <span className="financeiro__container__cabecalho__totais--titulos">
                Total a Receber
              </span>
              <div className="financeiro__container__cabecalho__totais--texto">
                <span className="financeiro__container__cabecalho__totais--saldo--valor_principal">
                  {financialData.totalReceber}$00
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {rows && (
        <div style={{ height: 635, width: "100%" }}>
          <DataGrid
            rows={rows}
            columns={actionColumn}
            pageSize={10}
            rowsPerPageOptions={[10]}
          />
        </div>
      )}

      {openModal === "procedimentos" && (
        <ModalVerOrcamento
          open={openModal === "procedimentos"}
          handleClose={handleCloseModal}
          data={modalData}
        />
      )}

      {openModal === "verEntrada" && (
        <ModalVerEntrada
          openModalVerEntrada={openModal === "verEntrada"}
          handleCloseModalVerEntrada={handleCloseModal}
          dadosModalVerEntrada={modalData}
        />
      )}

      {corrigirCaixa && (
        <ModalCorrigirCaixa
          open={!!corrigirCaixa}
          tipo="entrada"
          id={corrigirCaixa}
          onFechar={() => setCorrigirCaixa(null)}
          /* A caixa e a descrição aparecem nesta lista e no fluxo de caixa. */
          onCorrigido={() =>
            fetchContasCorrentesEntrada(periodoAtual.inicio, periodoAtual.fim)
          }
        />
      )}

      {openModal === "entrada" && (
        <ModalEntrada
          openModalEntrada={openModal === "entrada"}
          sendRequest={sendRequest}
          handleCloseModalEntrada={handleCloseModal}
          clinicaId={clinicaId}
          auth={auth}
          updateEntradas={updateEntradas}
          modoContingenciaAtivo={modoContingenciaAtivo}
        />
      )}

      {openModal === "editarEntrada" && (
        <ModalEditarEntrada
          openModalEditarEntrada={openModal === "editarEntrada"}
          sendRequest={sendRequest}
          handleCloseModalEditarEntrada={handleCloseModal}
          clinicaId={clinicaId}
          auth={auth}
          updateEntradas={updateEntradas}
          entradaId={entradaId}
          modoContingenciaAtivo={modoContingenciaAtivo}
        />
      )}

      {openModal === "receberEntrada" && (
        <ModalReceberEntrada
          openModalReceberEntrada={openModal === "receberEntrada"}
          sendRequest={sendRequest}
          handleCloseModalReceberEntrada={handleCloseModal}
          auth={auth}
          updateEntradas={updateEntradas}
          dadosModalReceberEntrada={modalData}
          clinicaId={clinicaId}
        />
      )}

      {dadosModalMotivoCancelamentoEntradas.open ===
        "motivoCancelamentoEntradas" && (
        <ModalMotivoCancelamentoEntradas
          open={
            dadosModalMotivoCancelamentoEntradas.open ===
            "motivoCancelamentoEntradas"
          }
          handleCloseModal={handleCloseModal}
          modalData={dadosModalMotivoCancelamentoEntradas}
          handleCancelarRecebimentoEntradaClienteFornecedor={
            handleCancelarRecebimentoEntradaClienteFornecedor
          }
          emitirNCE={emitirNCE}
          clinica={clinica}
          auth={auth}
        />
      )}

      {/* DIALOG DE CONTINGÊNCIA */}
      <Dialog
        open={dialogContingenciaOpen}
        onClose={handleDialogContingenciaClose}
        aria-labelledby="contingencia-dialog-title"
        aria-describedby="contingencia-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          id="contingencia-dialog-title"
          sx={{
            backgroundColor: "#fff3cd",
            color: "#856404",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <ErrorIcon sx={{ color: "#ff9800" }} />
          Emissão em Modo Contingência
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            <strong>Modo Contingência Ativo</strong>
          </Alert>

          <DialogContentText sx={{ mb: 2 }}>
            O documento será emitido em <strong>modo de contingência</strong> e
            transmitido posteriormente quando o servidor E-fatura estiver
            disponível.
          </DialogContentText>

          <Alert severity="info" sx={{ mt: 2, mb: 2 }}>
            <Typography variant="body2">
              Selecione o motivo da emissão em contingência:
            </Typography>
          </Alert>

          <div className="customInputContainer">
            <select
              className="customInputSelect"
              value={motivoContingenciaSelecionado}
              onChange={(e) =>
                setMotivoContingenciaSelecionado(Number(e.target.value))
              }
            >
              {MOTIVOS_CONTINGENCIA.map((motivo) => (
                <option key={motivo.codigo} value={motivo.codigo}>
                  {motivo.label}
                </option>
              ))}
            </select>
            <label className="customInputLabelSelect">
              Motivo da Contingência *
            </label>
          </div>

          {motivoContingenciaSelecionado === 0 && (
            <TextField
              fullWidth
              multiline
              rows={3}
              label="Descreva o motivo *"
              value={descricaoContingenciaOutro}
              onChange={(e) => setDescricaoContingenciaOutro(e.target.value)}
              sx={{ mt: 2 }}
              placeholder="Especifique o motivo da emissão em contingência..."
            />
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            onClick={handleDialogContingenciaClose}
            color="inherit"
            variant="outlined"
          >
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmarContingencia}
            color="warning"
            variant="contained"
            autoFocus
            startIcon={<ErrorIcon />}
            disabled={
              motivoContingenciaSelecionado === 0 &&
              descricaoContingenciaOutro.trim().length < 10
            }
          >
            Confirmar Emissão
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Receitas;
